const TIME_MULTER = 1000;

export const dateHR = (value: number) => {
  return new Date(value * TIME_MULTER).toLocaleDateString(
    "en-US",
    {
      day: "numeric",
      month: "short",
      year: "numeric",
    }
  );
};

export const dateTimeHR = (value: number) => {
  return (new Date(value * TIME_MULTER)).toLocaleString();
};
